import React, { useRef, useState } from 'react';
import { RootReducer } from 'store/root-reducer';
import { connect } from 'react-redux';
import { useIsomorphicLayoutEffect } from '@navi-toolbox/hooks';
import { Typography } from 'fronton-react';
import { getDisplayedName, getProductImages } from 'features/product-info/ducks/selectors';
import { getSeoH1Text } from 'features/page-model/ducks/get-model';
import { Picture } from 'features/product-info/components/pdp-media-gallery/preview/picture';
import { Url } from 'features/product-info/types';
import { PdpPriceView } from 'features/product-info/components/pdp-price-view';
import { getCartItem } from 'features/basket';
import { useBreakpoints } from 'common/hooks';
import { getArticle } from 'common/selectors';
import { VariantPreviewWrapper, secondPrice, oldNewPrice, picture } from './styles';

type VariantDrawerPreviewProps = {
  images?: Url[];
  altValue: string;
  productName?: string | null;
  inBasket: boolean;
  quantity: number;
};

const PADDING = 32;

const VariantDrawerPreview: React.FC<VariantDrawerPreviewProps> = ({
  images,
  altValue,
  productName,
  inBasket,
  quantity,
}) => {
  const { mobile } = useBreakpoints() || { mobile: false };

  const ref = useRef<HTMLDivElement | null>(null);
  const [height, setHeight] = useState<number>();

  useIsomorphicLayoutEffect(() => {
    if (ref?.current && !mobile) {
      setHeight(ref.current.clientHeight - PADDING);
    }
  }, [ref, mobile]);

  return images?.length ? (
    <VariantPreviewWrapper ref={ref}>
      <div>
        <Picture
          alt={altValue}
          src={images[0].url || ''}
          zoomOnHover={false}
          className={picture}
          size={height}
        />
      </div>
      <div>
        <div data-qa="drawer-preview-title">
          <Typography color="text-primary" variant="s" size="body_long">
            {productName}
          </Typography>
        </div>
        <div data-qa="drawer-preview-price">
          <PdpPriceView
            isStickyPanel={false}
            className={oldNewPrice}
            secondPriceClassName={secondPrice}
            inBasket={inBasket}
            quantity={quantity}
          />
        </div>
      </div>
    </VariantPreviewWrapper>
  ) : null;
};

const mapStoreToProps = (store: RootReducer) => {
  const images = getProductImages(store);
  const productName = getDisplayedName(store);

  const altValue = getSeoH1Text(store) || '';
  const productId = getArticle(store) || '';
  const cartEntity = getCartItem(productId)(store);
  const inBasket = !!cartEntity;
  const quantity = cartEntity?.quantity || 0;

  return {
    productName,
    images,
    altValue,
    inBasket,
    quantity,
  };
};
export const PdpVariantDrawerPreview = connect(mapStoreToProps, null)(VariantDrawerPreview);
